import React from 'react';

import {observer} from 'mobx-react';
import {MenuItem, MenuList} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';

import {useStores} from '../../../Hooks';
import {trainingAndFieldRoleEnum} from '../../../serverClientShared/sharedEnums';
import ConditionalComponent from '../../Shared/ConditionalComponent';
import EllipsisContainer from '../../Shared/EllipsisContainer';

const labelClass = 'text-xs font-semibold text-main-normal block mb-0.5';
const textClass = 'text-xs text-main-normal';

const RoleVisibilitySection = observer(({permittedRoles, onToggle}) => {
    const {generalStore} = useStores();
    const translateRole = (role) => {
        if (role === trainingAndFieldRoleEnum.OPERATOR_3D) return 'Operator MR';
        return generalStore.translate(role);
    };

    return (
        <div data-testid="role-visibility-section">
            <span className={labelClass}>{generalStore.translate('visibleTo')}</span>
            <MenuList style={{maxHeight: 180, overflow: 'auto', padding: 0}}>
                {Object.values(trainingAndFieldRoleEnum)
                    .filter((r) => r !== trainingAndFieldRoleEnum.NONE)
                    .map((role) => (
                        <MenuItem key={role} data-testid={`role-visibility-${role}`} data-active={!!permittedRoles?.[role]} onClick={() => onToggle(role)} style={{padding: '2px 0px', minHeight: 28}}>
                            <div className="flex items-center justify-between w-full">
                                <EllipsisContainer value={translateRole(role)}><span className={textClass}>{translateRole(role)}</span></EllipsisContainer>
                                <ConditionalComponent if={!!permittedRoles?.[role]}><DoneIcon style={{fontSize: 18, color: 'var(--classicbutton-normal-color)'}} /></ConditionalComponent>
                            </div>
                        </MenuItem>
                    ))}
            </MenuList>
        </div>
    );
});

export default RoleVisibilitySection;
